import { createContext } from 'react';
import actionCable from 'actioncable';

export const cable = actionCable.createConsumer('/cable');
export const ActionCableContext = createContext();
